'use strict';

var _class, _temp;

var _three = require('three');

var THREE = _interopRequireWildcard(_three);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CameraUtils = (_temp = _class = function CameraUtils() {
  _classCallCheck(this, CameraUtils);
}, _class.current = null, _temp);


module.exports = CameraUtils;


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-three-renderer/lib/utils/CameraUtils.js
 ** module id = 332
 ** module chunks = 0
 **/